const twoBlockGridWithAccordion = () => {
    const twoBlockGridWithAccordionWidgetList = document.querySelectorAll("[data-two-block-grid-with-accordion-widget]");
    if (twoBlockGridWithAccordionWidgetList && twoBlockGridWithAccordionWidgetList.length > 0) {
        twoBlockGridWithAccordionWidgetList.forEach((twoBlockGridWithAccordionWidget) => {
            const accordionItemList = twoBlockGridWithAccordionWidget.querySelectorAll("[data-accordion-item]");
            if (accordionItemList && accordionItemList.length > 0) {
                accordionItemList.forEach((accordionItem) => {
                    const toBeToggled = accordionItem.querySelector("[data-to-be-toggled]");
                    toBeToggled.addEventListener("click", () => {
                        accordionItemList.forEach(x => x.classList.remove("active"));
                        accordionItem.classList.add("active");
                    });
                });
            }
        });
    }
};
